import React from 'react';
import { Button, TrustBar } from './Shared';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const STATS = [{
  value: '+500',
  label: 'docentes confían'
}, {
  value: '8',
  label: 'Tomos por tramo listos'
}, {
  value: '4,9/5',
  label: 'calificación ⭐'
}, {
  value: '🇺🇾',
  label: 'Todo Uruguay — primaria'
}];
const HERO_TESTIMONIALS = [{
  initials: 'AG',
  quote: 'Organicé todo el año en una tarde',
  author: 'Ana G., Montevideo',
  tag: '5° y 6° año'
}, {
  initials: 'MF',
  quote: 'Mis clases por fin tienen estructura',
  author: 'Marcela F., Rivera',
  tag: 'Inicial y 1°'
}, {
  initials: 'RB',
  quote: 'Nunca más llegué sin material a clase',
  author: 'Roberto B., Salto',
  tag: '3° y 4° año'
}];
export function Hero() {
  return <section className="pt-6 pb-14 md:pt-12 md:pb-20 px-4 bg-gradient-to-b from-brand-lightBlue to-brand-base flex flex-col items-center justify-center text-center relative overflow-hidden" data-id="element-66">
      <div className="max-w-4xl mx-auto relative z-10 w-full" data-id="element-67">
        {/* Brand Tag */}
        <div className="text-brand-orange font-bold tracking-widest text-xs md:text-base mb-3 md:mb-6 flex items-center justify-center gap-2 uppercase" data-id="element-68">
          🌟 Tu Fénix Digital
        </div>

        {/* Headline */}
        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-display font-bold text-brand-deep leading-[1.1] mb-4 md:mb-8" data-id="element-69">
          Todo tu año de Primaria{' '}
          <span className="text-brand-orange" data-id="element-70">Resuelto.</span>
          <br data-id="element-71" />
          Todo un negocio educativo{' '}
          <span className="text-brand-orange" data-id="element-72">en tus manos.</span>
        </h1>

        {/* Product Image */}
        <div className="relative max-w-[240px] sm:max-w-xs md:max-w-xl mx-auto mb-5 md:mb-10" data-id="element-73">
          <img src="https://cdn.magicpatterns.com/uploads/53pSu5ZqyJEKnLdMyRrx7p/ChatGPT_Image_29_jun_2026,_12_05_51_a.m..png" alt="Aula de Éxitos - Recursos Digitales para Primaria" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(13,59,110,0.2)]" data-id="element-74" />
        </div>

        {/* Subheadline */}
        <p className="text-base md:text-xl text-brand-text mb-5 md:mb-8 max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-75">
          El sistema que usan los docentes de Primaria uruguayos para planificar
          todo el año en una tarde e incluso generar ingresos extra con sus
          horas libres o montar su propio emprendimiento educativo desde cero.
        </p>

        {/* Pills */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-6 md:mb-10" data-id="element-76">
          {['📄 100% PDF', '⚡ Acceso inmediato', '🇺🇾 EBI · ANEP Uruguay 2026'].map((pill, i) => <span key={i} className="bg-white border border-brand-sky text-brand-blue px-4 py-1.5 md:px-5 md:py-2 rounded-full text-xs md:text-sm font-semibold shadow-sm" data-id="element-77">
              {pill}
            </span>)}
        </div>

        {/* CTA Button */}
        <div className="max-w-md mx-auto mb-4" data-id="element-78">
          <Button className="py-4 md:py-5 text-lg md:text-xl" data-id="element-79">
            🌟 QUIERO MI AULA DE ÉXITOS AHORA
          </Button>
        </div>

        {/* Trust Badges */}
        <TrustBar data-id="element-80" />

        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-14 mb-10" data-id="element-81">
          {STATS.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white border border-brand-sky rounded-2xl py-6 px-3 shadow-sm flex flex-col items-center justify-center" data-id="element-82">
              <div className="text-3xl md:text-4xl font-display font-bold text-brand-blue mb-1" data-id="element-83">
                {stat.value}
              </div>
              <div className="text-sm text-brand-text font-medium leading-tight" data-id="element-84">
                {stat.label}
              </div>
            </motion.div>)}
        </div>

        {/* Hero Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-left" data-id="element-85">
          {HERO_TESTIMONIALS.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm flex flex-col" data-id="element-86">
              <div className="flex text-yellow-400 mb-3" data-id="element-87">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-88" />)}
              </div>
              <p className="text-brand-deep font-semibold mb-4 flex-1" data-id="element-89">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-90">
                <div className="w-10 h-10 bg-brand-blue text-white rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-91">
                  {t.initials}
                </div>
                <div data-id="element-92">
                  <div className="font-bold text-sm text-brand-text" data-id="element-93">
                    {t.author}
                  </div>
                  <div className="text-xs text-brand-gray" data-id="element-94">{t.tag}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}